import styled from 'styled-components'

const ActionStyles = styled.div`
  padding: 4px;
  box-sizing: border-box;
  cursor: pointer;
  outline: 0;
  user-select: none;
  .reaction {
    min-width: 24px;
    height: 24px;
    background-size: cover;
  }
  .reaction-animation {
    animation-delay: 0.2s;
    ${({ animated }) => animated && `
      animation-duration: 1s;
    `}
    animation-iteration-count: 1;
    animation-timing-function: steps(24);
    animation-name: animate-sprite;
    animation-fill-mode: forwards;
  }
  .step-like {
    background-image: url(/images/sprites/like-gray.png);
  }
  .step-wand {
    background-image: url(/images/sprites/wand-gray.png);
  }
  .step-nogiveup {
    background-image: url(/images/sprites/nogiveup-gray.png);
  }
  .step-like-animated {
    background-image: url(/images/sprites/like-sprite.png);
  }
  .step-wand-animated {
    background-image: url(/images/sprites/wand-sprite.png);
  }
  .step-nogiveup-animated {
    background-image: url(/images/sprites/nogiveup-sprite.png);
  }
  @keyframes animate-sprite {
    from { background-position: 0; }
    to { background-position: -576px; }
  }
  .action__container {
    position: relative;
    display: flex;
    align-items: center;
    span {
      flex-grow: 1;
      font-family: var(--secondaryFont);
      font-weight: 500;
      margin-left: 6px;
      color: var(--baseFullContrast);
      outline: 0;
      user-select: none;
    }
    :active > svg > path {
      fill: var(--gray);
    }
    :hover .arrow_container {
      display: initial;
    }
  }
  .arrow_container {
    display: none;
    position: absolute;
    top: -38px;
    left: ${({ left }) => (left ? `${left}px` : '-40px')};
    z-index: 30;
    font-size: 14px;
  }
  .arrow_box {
    text-align: center;
    position: relative;
    background: var(--baseSecondary);
    color: var(--basePrimary);
    padding: 4px 8px;
    box-sizing: border-box;
    background-color: #E8EAEF;
    border-radius: 6px;
    width: ${({ width }) => (width ? `${width}px` : 'fit-content')};
  }

  .arrow_box:after, .arrow_box:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .arrow_box:after {
    border-color: rgba(33, 36, 41, 0);
    border-top-color: #E8EAEF;
    border-width: 5px;
    margin-left: -5px;
  }
  .arrow_box:before {
    border-color: rgba(0, 0, 0, 0);
    border-width: 5px;
    margin-left: -5px;
  }
  svg path {
    fill: ${({ reacted }) => (reacted ? 'var(--turquoise);' : 'var(--neutral60)')};
  }
  @media (min-width: 768px) {
    .action__container {
      min-width: 50px;
    }
  }
`

export default ActionStyles
